import React from 'react';
import Modal from '../../../Components/Modal/Modal';
import { Size } from '../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import CaseCloseComponent from './CaseCloseComponent';

interface CaseCloseComponentModalProps {
	caseId: string;
	patientId: string;
	onClose: () => void;
	onCaseClose: () => void;
	opened: boolean;
	isMedicalReportRequired: boolean;
}

const CaseCloseComponentModal: React.FC<
	CaseCloseComponentModalProps
> = props => {
	const { isCase } = useTreatmentContext();

	return (
		<>
			<Modal
				opened={props.opened}
				onClose={props.onClose}
				wrapChat={isCase}
				size={Size.MD}
				forceClose>
				<Modal.Header title={'base.shared.closeCase'} firstUpper />
				<Modal.Content contentScroll={true}>
					<CaseCloseComponent {...props} />
				</Modal.Content>
			</Modal>
		</>
	);
};

export default CaseCloseComponentModal;
